/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  getWorkScheduleAssignList,
  getWorkScheduleList,
} from "../../../apis/work-schedule";
import { get, isEmpty } from "lodash";
import WorkScheduleTable from "./Component/WorkScheduleTable";
import Management from "./Management";
import NoData from "../../../components/NoData/NoData";

const ManagementList = ({ detailOpen, setDetailOpen, mode, setMode, permission }) => {
  const [workscheduleList, setWorkScheduleList] = useState([]);
  const [params, setParams] = useState({});
  const [workscheduleData, setWorkscheduleData] = useState({});

  useEffect(() => {
    submit(params);
  }, [params, mode]);

  const submit = ({ isFilter, ..._params } = {}) => {
    if (isFilter) {
      !isEmpty(_params.title) ? setParams(_params) : setParams({});
      return;
    }
    getWorkScheduleList({ search: { ...params } }).then((res) => {
      setWorkScheduleList(res.data.schedules);
    });
  };

  return (
    <>
      {!isEmpty(workscheduleList) ? (
        workscheduleList.map((workschedule, idx) => (
          <WorkScheduleTable
            key={idx}
            title={get(workschedule, "title")}
            api={getWorkScheduleAssignList}
            apiFilter={{ search: { scheduleIdx: workschedule.idx } }}
            dataKey={"assignes"}
            params={params}
            submit={() => submit(params)}
            tableInfo={workschedule}
            setDetailOpen={setDetailOpen}
            setMode={setMode}
            setWorkscheduleData={setWorkscheduleData}
            permission={permission}
          />
        ))
      ) : (
        <NoData></NoData>
      )}
      <Management
        open={detailOpen}
        setOpen={setDetailOpen}
        mode={mode}
        setMode={setMode}
        formData={workscheduleData}
        setFormData={setWorkscheduleData}
        submit={() => submit(params)}
      />
    </>
  );
};

export default ManagementList;
